/* eslint-disable */

import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import RaindropButton from "../raindrop-button/raindrop-button.tsx";
import OrganisationLogo from "../organisation-logo/organisation-logo";
import DateFormat from "../date-format/date-format.tsx";

import RaindropTextParagraph from "../raindrop-text-paragraph/raindrop-text-paragraph.tsx";

import RaindropTextSubtitle from "../raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import FlexRow from "../flex-row/flex-row.tsx";

const OrganisationActivityButtons = ({
  externalUrl = null,
  onShare = () => {},
  onLike = () => {},
}) => {
  return (
    <div className="flex flex-row gap-2 w-full">
      {externalUrl && (
        <RaindropButton
          title={"Read more"}
          icon={"fa-link"}
          to={externalUrl}
          isFluid={true}
        />
      )}
    </div>
  );
};

const OrganisationActivityHeader = ({
  organisationId,
  organisationName,
  organisationPresignedUrl,
  createdAt,
}) => {
  return (
    <a
      className="flex flex-row items-center gap-2 w-full"
      href={`/raindrop/organisation/${organisationId}`}
    >
      <OrganisationLogo src={organisationPresignedUrl} />
      <div className="flex flex-col text-left">
        <h1 className="font-bold ">{organisationName}</h1>
        <div className="flex flex-row gap-2 items-center text-sm text-color-dark-text-secondary">
          <DateFormat dateIsoString={createdAt} />
        </div>
      </div>
    </a>
  );
};

const OrganisationActivityBody = ({ text }) => {
  return (
    <div className="bg-color-background-primary dark:bg-color-dark-background-tertiary p-2 px-4 rounded-xl">
      <RaindropTextParagraph>{text}</RaindropTextParagraph>
    </div>
  );
};

const YouSupportedThisBadge = () => {
  return (
    <FlexRow>
      <i className="fa fa-star text-yellow-500 text-xl" />
      <RaindropTextSubtitle>You supported this</RaindropTextSubtitle>
    </FlexRow>
  );
};

const OrganisationActivityElement = ({
  organisationId = "fake-organisation-id",
  organisationName = "Fake Organisation",
  organisationPresignedUrl = "#",
  createdAt = "2021-10-10",
  text = "This is a test activity",
  externalUrl = null,
  didContribute = false,
  onShare = () => {},
  onLike = () => {},
}) => {
  // TODO: Make this true.  Add liking and sharing.
  const showActivityButtons = true;

  return (
    <RaindropCard>
      <OrganisationActivityHeader
        organisationName={organisationName}
        createdAt={createdAt}
        organisationPresignedUrl={organisationPresignedUrl}
        organisationId={organisationId}
      />

      <OrganisationActivityBody text={text} />

      <YouSupportedThisBadge />

      {showActivityButtons && (
        <OrganisationActivityButtons
          externalUrl={externalUrl}
          onShare={onShare}
          onLike={onLike}
        />
      )}
    </RaindropCard>
  );
};

export default OrganisationActivityElement;
